import { Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableTimeCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  disabled,
  inlineEdit
}) {
  return (
    <td onClick={e => e.stopPropagation()}>
      <Field className="has-addons">
        <Control className={inlineEdit ? "time-cell" : ""}>
          <Input
            className="small-row-black"
            onChange={onChange}
            type="time"
            name={propName}
            value={value || ""}
            disabled={!editable}
          />
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
      </Field>
    </td>
  );
}

export default useEditableTableTimeCell;
